import { ENVIRONMENT_QUAL } from './qual';

export const environment = {
  ...ENVIRONMENT_QUAL,
  apiServer: 'https://dabronx.app.1life.com',
  myoneServer: 'https://dabronx.app.1life.com',
  sentry: {
    enabled: true,
    dsn: 'https://94fb2cb964527591835f763ad4493a4f@o4506221115408384.ingest.us.sentry.io/4506855554154496',
    environment: 'onelife-dabronx',
  },
  mixpanelDebug: true,
  launchDarklyClientId: '605034c0a544ec0cd24ff961',
};
